export default "__VITE_ASSET__0ftZAZgI__"